// UserTable.js
import React from 'react';

const UserTable = ({ users, onEdit, onPromote, onDelete, getRoleName, getRoleBadgeClass }) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white">
            <th className="px-6 py-4 text-left font-semibold">User</th>
            <th className="px-6 py-4 text-left font-semibold">Email</th>
            <th className="px-6 py-4 text-left font-semibold">Role</th>
            <th className="px-6 py-4 text-left font-semibold">Department</th>
            <th className="px-6 py-4 text-left font-semibold">Batch</th>
            <th className="px-6 py-4 text-left font-semibold">Status</th>
            <th className="px-6 py-4 text-center font-semibold">Actions</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {users.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center py-12 text-gray-500 text-lg">
                <div className="flex flex-col items-center">
                  <span className="text-4xl mb-2">😔</span>
                  <span>No users found</span>
                </div>
              </td>
            </tr>
          ) : (
            users.map((user, index) => (
              <tr 
                key={user._id} 
                className={`border-b border-gray-100 hover:bg-blue-50/50 transition-colors ${
                  index % 2 === 0 ? 'bg-gray-50/30' : 'bg-white'
                }`}
              >
                <td className="px-6 py-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-400 to-indigo-500 flex items-center justify-center text-white font-bold shadow-md">
                      {user.firstName[0]}{user.lastName[0]}
                    </div>
                    <div>
                      <div className="text-gray-800 font-semibold">{user.firstName} {user.lastName}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 text-gray-600">{user.email}</td>
                <td className="px-6 py-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getRoleBadgeClass(user.profileLevel)}`}>
                    {getRoleName(user.profileLevel)}
                  </span>
                </td>
                <td className="px-6 py-4 text-gray-600">{user.department || 'N/A'}</td>
                <td className="px-6 py-4 text-gray-600">{user.batch || 'N/A'}</td>
                <td className="px-6 py-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    user.accountDeleted ? 'bg-red-100 text-red-800 border border-red-200' : 
                    user.validated ? 'bg-green-100 text-green-800 border border-green-200' : 
                    'bg-yellow-100 text-yellow-800 border border-yellow-200'
                  }`}>
                    {user.accountDeleted ? '🚫 Deleted' : user.validated ? '✅ Active' : '⏳ Pending'}
                  </span>
                </td>
                <td className="px-6 py-4">
                  <div className="flex justify-center space-x-2">
                    <button 
                      className="bg-blue-100 hover:bg-blue-200 text-blue-700 px-3 py-2 rounded-lg transition-all duration-200 border border-blue-200 hover:border-blue-300 font-medium"
                      onClick={() => onEdit(user)}
                    >
                      ✏️ Edit
                    </button>
                    <button 
                      className="bg-green-100 hover:bg-green-200 text-green-700 px-3 py-2 rounded-lg transition-all duration-200 border border-green-200 hover:border-green-300 font-medium"
                      onClick={() => onPromote(user)}
                    >
                      🔄 Role
                    </button>
                    <button 
                      className="bg-red-100 hover:bg-red-200 text-red-700 px-3 py-2 rounded-lg transition-all duration-200 border border-red-200 hover:border-red-300 font-medium"
                      onClick={() => onDelete(user._id)}
                    >
                      🗑️ Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
